var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: `mb-3 d-flex align-items-center position-relative`
  }, [_c('div', {
    class: `lineOnlyForIVR`,
    staticStyle: {
      "align-self": "stretch",
      "width": "200px"
    }
  }, [_c('div', {
    staticClass: "lineOnlyForIVR-y"
  }), _c('div', {
    staticClass: "lineOnlyForIVR-x"
  })]), _vm._m(0), _c('div', {
    staticClass: "textAboveHorizontalLine"
  }, [_vm._v("Press Option " + _vm._s(_vm.option.user_dtmf))]), _c('div', {
    staticClass: "nodeBasic-new"
  }, [_c('Info', {
    attrs: {
      "id": _vm.option.ivr_cmd_args,
      "is_blf": false
    }
  }), _c('div', {
    class: `d-flex ${_vm.forwardInfo && _vm.forwardInfo.type == 'ivr' ? 'justify-content-between' : 'justify-content-end'} align-items-center w-100 mt-3 position-relative`
  }, [_vm.forwardInfo && _vm.forwardInfo.type == 'ivr' ? _c('vb-audio-player', {
    staticClass: "audioForMobile",
    attrs: {
      "src": _vm._f("welcomgreetingsrc")(_vm.forwardInfo.data),
      "design": 'minimum'
    }
  }) : _vm._e(), _c('b-icon', {
    staticClass: "cursor_pointer ml-3",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "icon": "pencil-fill",
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('updateDTMF');
      }
    }
  }), _c('b-icon', {
    staticClass: "cursor_pointer ml-3",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "icon": "trash-fill",
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('deleteDTMF');
      }
    }
  })], 1)], 1), _vm.members.length > 0 ? [_vm._m(1), _c('div', {
    staticClass: "nodeBasic-new"
  }, [_vm._l(_vm.firstFourMembers, function (member) {
    return _c('div', {
      key: member.key,
      staticClass: "mb-2"
    }, [_c('Info', {
      attrs: {
        "id": member.key,
        "type": 'USER',
        "is_blf": false
      }
    })], 1);
  }), _vm.members.length > 4 ? _c('div', {
    staticClass: "d-flex justify-content-end w-100 mt-4"
  }, [_c('div', {
    staticStyle: {
      "color": "rgb(85, 118, 209)",
      "font-weight": "600",
      "font-size": "16px"
    }
  }, [_vm._v(" " + _vm._s(_vm.members.length - 4) + " more members ")])]) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-end mt-8px"
  }, [_c('vb-icon', {
    staticClass: "cursor_pointer graphIconInsideGraph-icon",
    attrs: {
      "icon": "graphIconInsideGraph-icon",
      "height": "32px",
      "width": "32px"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('showGraph');
      }
    }
  })], 1)], 2)] : _vm._e()], 2);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "lineWithArrow right longLine-150px pt-0 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "lineWithArrow-line"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "lineWithArrow right longLine-150px pt-0 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "lineWithArrow-line"
  })]);

}]

export { render, staticRenderFns }